/** @format */

import React, { FunctionComponent } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '../../../components/Card/CardHeader';
import { Typography } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import { DateHelper } from '../../../helpers/DateHelper';
import CardBody from '../../../components/Card/CardBody';
import XmlView from './XmlView';
import { PlusOrdersCommonResponse } from '../../../interfaces/platform/PlusOrdersCommonResponse';

export type PlusOrdersCommonResponseElement = {
    item: PlusOrdersCommonResponse;
};

function getRequest(responseMessage: any | null): string | null {
    if (responseMessage && responseMessage.JSON_REQUEST) {
        return responseMessage.JSON_REQUEST;
    }
    if (!responseMessage || !responseMessage.XML_REQUEST) {
        return null;
    }
    return responseMessage.XML_REQUEST;
}

function getResponse(responseMessage: any | null): string | null {
    if (responseMessage && responseMessage.JSON_RESPONSE) {
        return responseMessage.JSON_RESPONSE;
    }
    if (!responseMessage || !responseMessage.XML_RESPONSE) {
        return null;
    }
    return responseMessage.XML_RESPONSE;
}

export const PlusOrdersCommonResponseView: FunctionComponent<PlusOrdersCommonResponseElement> = ({ item }): any => {
    let json: any = null;
    let errorMessage: string | null = null;
    let request: string | null = item.requestQuery;
    let response: string | null = item.responseQuery;
    let apiRequest = false;

    if (item.command === 'REST_API_CALL') {
        apiRequest = true;
    }

    if (!apiRequest && (!request || !response) && item.messageJson) {
        json = JSON.parse(item.messageJson);
        if (!request) {
            request = getRequest(json);
        }

        if (!response) {
            response = getResponse(json);
        }
    }

    if (apiRequest) {
        json = JSON.parse(item.messageJson);
        if (item.direction === 'GET') {
            request = item.requestUri ?? '';
        } else {
            request = getRequest(json);
        }
        response = getResponse(json);
    }

    if (request === null && json && json.errorMsg) {
        errorMessage = json.errorMsg;
    }
    if (request === null && json && json.RSTATUS === 'SYSTEMERROR') {
        errorMessage = json.RDESC;
    }

    return (
        <Card>
            <CardHeader>
                <Typography variant="subtitle2">
                    <I18n trans="prov:api.api_plk_request_wc" valueObject={{ time: DateHelper.format(item.requestTime) }} />
                </Typography>
            </CardHeader>
            <CardBody>
                {!apiRequest && request && XmlView(request)}
                {apiRequest && (
                    <>
                        {request}
                        <br />
                        <br />
                    </>
                )}
                {errorMessage}
            </CardBody>
            <CardHeader>
                <Typography variant="subtitle2">
                    <I18n trans="prov:api.api_plk_response" valueObject={{ time: DateHelper.format(item.responseTime) }} />
                </Typography>
            </CardHeader>
            <CardBody>
                {!apiRequest && response && XmlView(response)}
                {apiRequest && (
                    <>
                        {response} <br />
                        <br />
                    </>
                )}
            </CardBody>
        </Card>
    );
};
